export const saleTypeFeatureTranslationJP = {
  SaleTypeListPage: {
    head_title: '販売タイプ一覧',
    add_new: '新規追加',
    detailed: '詳細',
    copy: '複製',
    delete: '削除',
    restore: '復元',
    selection: '選択',
    sale_type_name: '販売タイプ名',
    timeframe: '時間帯',
    timeframe_name: '時間帯名',
    timeframe_time: '平日時間',
    timeframe_holiday_time: '休日時間',
    timeframe_busy_time: '繁忙期時間',
    eating_way_selection: '起動時食べ方選択',
    menu_book_edit: '食べ方選択編集',
    warn_confirm_delete: '選択された販売タイプを削除します。<br/>よろしいですか？',
    warn_confirm_restore: '選択された販売タイプを復元します。<br/>よろしいですか？',
  },
  SaleTypeDetail: {
    head_title: '販売タイプ詳細',
    close: '閉じる',
    save: '保存',
    register_timeframe: '時間帯登録',
    timeframe_name: '時間帯名',
    timeframe_guide: '適用時間は、繁忙期＞休日＞平日の優先順位で適用されます。',
    apply_time: '適用時間',
    timeframe_time: '平日',
    timeframe_holiday_time: '休日',
    timeframe_busy_time: '繁忙期',
    begin: '開始',
    end: '終了',
    undefined: '指定なし',
    property: 'プロパティ',
    property_note:
      '※時間帯プロパティを指定するとメ<br/>ニュー詳細の表示条件で指定した時<br/>間帯限定メニューを表示することが<br/>できます',
    add_row: '行追加',
    warn_field_required: 'この項目は必須です',

    warn_timeframe_invalid: '平日の時間帯が無効です。もう一度確認してください。',
    warn_timeframe_intersection:
      '平日の時間帯の適用時間は、他の平日の時間帯と重複できません。適用時間を変更してください。',
    warn_holiday_timeframe_invalid: '休日期間時間が無効です。もう一度確認してください。',
    warn_holiday_timeframe_intersection:
      '休日時間帯の適用時間は他の休日時間帯と重複できません。適用時間を変更してください。',
    warn_busy_timeframe_invalid: '繁忙期間時間が無効です。もう一度確認してください。',
    warn_busy_timeframe_intersection:
      '繁忙時間帯の適用時間は他の繁忙時間帯と重複できません。適用時間を変更してください。',

    warn_confirm_delete_timeframe: '選択された時間帯を削除します。<br/>よろしいですか？',
    check_menu_book_note: '販売タイプが変更されました。表示する食べ方とメニューブックをご確認ください。',
    delete_successful: 'データを削除しました',
    warn_confirm_restore_timeframe: '選択された時間帯を復元します。<br/>よろしいですか？',
    restore_successful: '削除データを復元しました',
    warn_input_end_date: '開始日が指定された場合、終了日は必須です',
    warn_min_end_date: '終了日は開始日より前の日付であってはなりません.',
    warn_invalid_date: '無効な日付形式です.',
  },
  TimeFrameMenuBook: {
    head_title: '時間帯別メニューブック編集',
    add_menu_book: 'メニューブック追加',
    sale_type: '販売タイプ',
    timeframe: '時間帯',
    guide_title: '※並び順の変更について',
    guide_description:
      'メニューブック／コースは選択して、キーボード操作で並び順を変更することができます。変更すると、モバイルオーダーのメニューブックボタンの並び順が変更になります。',
    selected_menu_book: '選択済メニューブック',
    course: 'コース',
  },
  SelectMenuBook: {
    head_title: 'メニューブック追加',
    search: '絞り込み',
    menu_book_name: 'メニューブック名',
    no_data_guide: '※リストにない場合は、こちらから追加',
    select_all: '全選択',
    unselect_all: '解除',
    reload: 'リロード',
    addition: '追加',
    course_name: 'コース名',
  },
  EatingWayTimeFrameModal: {
    head_title: '時間帯別食べ方選択編集',
    note1:
      '※食べ方に設定している画像から言語ごとに表示を切り替<br/>え確認することだ出来ます。日本語以外の言語で登録がない<br/>言語の画像は英語画像が表示されます。',
    note2:
      'タブレットオーダーの起動モード選択画面で表示する食べ<br/>方とその表示位置を編集する画面です。<br/>※イメージなので実機と異なる場合がございます。実際の表示は実機でご確認ください。',
    sale_type: '販売タイプ',
    time_frame: '時間帯',
    num_area: '選択数',
    pattern_type: 'レイアウト',
    language: '言語',
    change_display: '表示切替',
    switch_layout: 'レイアウト切替',
    save: '保存',
    image: '画像',

    default_flg_button: 'スマホ',
    default_flg_button1: 'オーダー',
    default_flg_button_show: '初期表示',
    default_flg_button_hide: '初期非表示',
  },
  SelectEatingWayModal: {
    head_title: '食べ方選択',
    search: '絞り込み',
    eating_way_name: '食べ方名',
    no_data_guide: '※リストにない場合は、こちらから追加',
    selection: '選択',
    eating_way: '食べ方',
    change: '変更',
    selected_menu_book: '選択されているメニューブック',
    japanese: '日本語',
    english: '英語',
    chinese_simplified: '中国語(簡体字)',
    chinese_traditional: '中国語(繁体字)',
    korean: '韓国語',
    vietnamese: 'ベトナム語',
    warn_image_required: '適用できる画像が存在しません。<br/>画像を設定してください。',
    warn_image_size: '{0}のための画像のサイズが適していません。<br>{1}<br>{2}',
  },
};
